import { render } from "./BaseNavbar.vue?vue&type=template&id=75616a9b&scoped=true"
import script from "./BaseNavbar.vue?vue&type=script&lang=js"
export * from "./BaseNavbar.vue?vue&type=script&lang=js"

import "./BaseNavbar.vue?vue&type=style&index=0&id=75616a9b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75616a9b"]])

export default __exports__